/** Trigger for skills/prompts context picker in 1:1 chat (group chat uses `@` for people). */
export const CONTEXT_MENTION_TRIGGER = '/';

/** Remote i18n may still ship "@ for …"; normalize to "/" for the context picker. */
export function normalizeContextTriggerHint(text: string): string {
  return text
    .replace(/,\s*@\s*for\b/gi, ', / for')
    .replace(/(^|\s)@\s*for\b/gi, '$1/ for');
}

export function resolveContextTriggerPlaceholder(
  translated: string | undefined,
  translationKey: string,
  fallback: string,
): string {
  const raw = translated?.trim();
  const text = !raw || raw === translationKey ? fallback : raw;
  return normalizeContextTriggerHint(text);
}

export type MentionState = {
  active: boolean;
  query: string;
  startIndex: number;
};

function findContextMentionTriggerIndex(textBeforeCursor: string): number {
  for (let i = textBeforeCursor.length - 1; i >= 0; i -= 1) {
    if (textBeforeCursor[i] !== CONTEXT_MENTION_TRIGGER) {
      continue;
    }
    const prev = i > 0 ? textBeforeCursor[i - 1] : '';
    if (i === 0 || /\s/.test(prev)) {
      return i;
    }
  }
  return -1;
}

export function getPromptMentionState(value: string, cursor: number): MentionState {
  const textBeforeCursor = value.slice(0, cursor);
  const triggerIndex = findContextMentionTriggerIndex(textBeforeCursor);
  if (triggerIndex < 0) {
    return { active: false, query: '', startIndex: -1 };
  }

  const afterTrigger = textBeforeCursor.slice(triggerIndex + 1);
  if (/\s/.test(afterTrigger)) {
    return { active: false, query: '', startIndex: -1 };
  }

  return { active: true, query: afterTrigger, startIndex: triggerIndex };
}
